import request from "../../utils/fetch";

export const createCorporatePlan = (postData) => request.post(`hr/package`, postData);

export const AllCorporatePlan = () => request.get(`hr/package`);

export const deleteCorporatePlane = ({ id }) => request.put(`hr/package/${id}`);

export const EditCorporatePlane = ({ id }) => request.get(`hr/package/${id}`);

export const UpdateCorporatePlane = (postData) => request.patch(`hr/package/${postData.id}`, postData);

